import React, { useState, useEffect } from 'react';

/**
 * Offline Indicator - subtle banner that appears when user loses connection.
 * Only shows in PWA mode or after service worker is active.
 * Non-intrusive - small bar at top, auto-hides when connection returns.
 */
const OfflineIndicator: React.FC = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => {
      setIsOffline(false);
    };

    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);

    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-cosmic-800 border-b border-divine-500/20 px-4 py-2 text-center">
      <p className="text-cream/70 text-xs">
        Offline mode - cached content available
        <span className="text-cream/40 ml-2">|</span>
        <span className="text-cream/40 ml-2">Offline - saved pages available</span>
      </p>
    </div>
  );
};

export default OfflineIndicator;
